// @ts-strict-ignore
import { I18nService } from 'rainbow-web-sdk/services/core/i18n.service';
import { Service } from 'rainbow-web-sdk/services/service';

export const ERROR_HELPER_SVC = 'ErrorHelperService';

export class ErrorHelperInfo {
    public message: string = '';
    public error: any = null;
}

export class ErrorHelperService extends Service {

    public static ERROR_CODE_LABELS: Record<string, string> = {
        "-1": "unknownError",
        "0": "errorNoServerResponse",
        "400": "badRequest",
        "400000": "badRequest",
        "400210": "invalidPhoneNumber",
        "400400": "errorWrongPassword",
        "400401": "newPasswordError",
        "400500": "invalidFile",
        "400504": "companyNameAlreadyExist",
        "400505": "BPCompanyWithoutPaymentConfigurationData",
        "400506": "NoActiveSubscriptionToOffer",
        "400509": "errorDecreaseSubscriptionForbidden",
        "400511": "ActiveDirectoryDomainAlreadyUsed",
        "400552": "BPCompanyAndECCompanyMustNotBeSame",
        "400601": "outboundAndInternalPrefixesCantBeIdentical",
        "400973": "noCreateUserPermission",
        "400975": "userAlreadyExistsInOtherCompany",
        "400990": "noUserFound",
        "400993": "noUserFound",
        "401": "authorizationFailure",
        "401102": "authorizationFailure",
        "401202": "errorInvalidToken",
        "401230": "externalStorageNotAuth",
        "401500": "errorUnauthorized",
        "401501": "errorAccountLocked",
        "401503": "2FA_verifCodeError",
        "401509": "2FA_recoveryCodeError",
        "401510": "errorUnauthorized",
        "401520": "errorUserNotActive",
        "401521": "errorUserNotActive",
        "401522": "errorAccountBeingSuppr",
        "403": "Forbidden",
        "403000": "accessDeniedNotRequiredRole",
        "403001": "accessDeniedNotOwner",
        "403005": "unableSendInvitationToDeletedAccount",
        "403034": "cantDeselectDefaultWebRTCGateway",
        "403035": "cantDeleteDefaultWebRTCGateway",
        "403036": "cantAddSystemToGroupDefaultWebRTCGatewayExists",
        "403038": "cantRemoveSystemWithDefaultWebRTCGateway",
        "403060": "confLockMsg",
        "403072": "errorIsoMd5Mismatch",
        "403083": "notAllowedToRemoveMember",
        "403153": "notAllowedOperation",
        "403154": "notAllowedToAccessMeeting",
        "403191": "dialInAlreadyEnabled",
        "403192": "dialInAlreadyDisabled",
        "403200": "notAllowedToChangeRole",
        "403203": "notAllowedToChangeRole",
        "403204": "notAllowedToMoveExistingUserToThisCompany",
        "403205": "notAllowedToManageUser",
        "403301": "notAllowedToManageCompany",
        "403303": "notAllowedOperation",
        "403304": "notAllowedToAddAnotherAdmin",
        "403311": "errorRemoveSyncOngoingSubscriptionForbidden",
        "403315": "errorRemoveSubscriptionForbidden",
        "403316": "errorRemoveAdminAllocatedSubscriptionForbidden",
        "403317": "errorRemoveClientAllocatedSubscriptionForbidden",
        "403400": "notAllowedDeleteAppOwner",
        "403500": "notAllowedBlacklistedEmail",
        "403501": "notAllowedBlacklistedEmail",
        "403502": "notAllowedToInviteExternalContacts",
        "403503": "NotAllowedSelfRegistrationEmail",
        "403504": "notAllowedLoggedInUserEmail",
        "403507": "notAllowedSupportEmail",
        "403513": "companyNotABpCompany",
        "403516": "companyNotABpCompany",
        "403517": "companySeenAsTerminated",
        "403518": "companyBpTypeIncompatible",
        "403519": "companyAlreadyLinkedToBp",
        "403520": "companyNotVadBp",
        "403525": "invitedUserIsolated",
        "403526": "isolatedUser",
        "403531": "resetPasswordBlocked",
        "403532": "resetPasswordForbidden",
        "403536": "inviteUserHotspotVisibility",
        "403537": "invitedUserHotspotVisibility",
        "403562": "notAllowedBecausePersonalRoutineActivated",
        "403563": "personalRoutine_invisible_forbidden2",
        "403608": "errorAssignSubscriptionSyncOngoing",
        "403609": "errorAssignSubscriptionSyncOngoing",
        "403610": "maxSubscriptionAllocationReached",
        "403611": "notAllowedToCreateAnEquipment",
        "403615": "maximumNumberConferenceParticipantsReach",
        "403616": "subscriptionCompanyAdminEssentialAlreadyExists",
        "403617": "roleCompanyAdminEssentialAlreadyExists",
        "403620": "maximumNumberReached",
        "403621": "MaximumNumberConvUsersReach",
        "403622": "userDoesNotHaveVoiceLicense",
        "403624": "notAllowedRemoveService",
        "403625": "errorAllocatedSubscriptionRemoveForbidden",
        "403626": "restrictedConvAccess",
        "403630": "uploadErrorMaxQuotaReached",
        "403631": "errorAssignSubscriptionRenewalVolumeReached",
        "403655": "userAlreadyCompanyMember",
        "403660": "userNotInDefaultCompany",
        "403670": "errorOperationForbiddenOnGuest",
        "403683": "errorOtherOperationInProgress",
        "403700": "errorDeleteSiteWithSystems",
        "403701": "errorDeleteOrganisationLinkedCompany",
        "403702": "errorDeleteCompanyWithSubscriptions",
        "403703": "errorDeleteCompanyWithSites",
        "403704": "errorDeleteCompanyWithUsers",
        "403705": "errorDeleteCompanyStillTerminated",
        "403706": "errorRemoveBusinessPartnerRole",
        "403719": "externalTrunkChangeForbidden",
        "403721": "numberingPlanCantBeUpdated",
        "403722": "outgoingPrefixChangeForbidden",
        "403723": "cannotRemoveCompanyPublicNumber",
        "403724": "notAllowedDeleteCloudPbxWithPublicNumbers",
        "403725": "notAllowedDeleteCloudPbxWithUsedExtensions",
        "403762": "forbiddenOperationGroupUsedByAutomatedAttendantMenu",
        "403770": "forbiddenOperationUserBelongsToGroup",
        "403780": "forbiddenOperationUserAlreadyManager",
        "403784": "forbiddenOperationGroupStillAssocToWelcome",
        "403785": "forbiddenOperationUserStillAssocToWelcome",
        "403786": "forbiddenOperationUserBelongsToGroup",
        "403792": "errorDialInLicenseAssignment",
        "403910": "errorOtherOperationInProgress",
        "403911": "errorOtherOperationInProgress",
        "404": "resourceNotFound",
        "404000": "resourceNotFound",
        "404001": "resourceNotFoundUpdateImpossible",
        "404002": "resourceNotFoundDeleteImpossible",
        "404116": "archivedOrDeletedConversation",
        "404300": "noValidOfferReferenceInACTISFile",
        "404301": "offerNotFound",
        "404751": "2FA_noMFAPolicyDefinedForCompany",
        "409000": "errorConflict",
        "409005": "inviteUsersError",
        "409011": "noMessagesToExport",
        "409212": "errorDeleteSiteWithSystems",
        "409251": "DDIAlreadyAssociatedToCompany",
        "409552": "internalNumberAlreadyUsed",
        "409555": "publicNumberAlreadyExists",
        "409557": "notAllowedDeleteUserAssociatedToCloudPbx",
        "409600": "userAlreadyExist",
        "409601": "invitationReSentConflict",
        "409602": "userAlreadyNetworkMember",
        "409603": "invitationReSentConflict",
        "409605": "joinCompanyConflict",
        "409620": "offerAlreadySubscribed",
        "409623": "conferenceOfferAlreadySubscribed",
        "409625": "errorUpdateSyncOngoingSubscriptionForbidden",
        "409800": "companyNotIrBp",
        "409801": "companyNotLinkedToBp",
        "409802": "actisCompanyAdminMismatch",
        "409803": "actisCompanyNameMismatch",
        "413000": "uploadErrorTooLarge",
        "415000": "audioFileTypeNotSupported",
        "429": "tooManyRequests",
        "429000": "tooManyRequests",
        "486065": "ccdNotAuthorizedAgentDeviceType",
        "486066": "ccdNoProACDDevice",
        "487060": "errorWrongPassword",
        "487063": "ccdLogonCommandRejected",
        "487064": "ccdLogonCommandRejectedWrongIdOrPassword",
        "487065": "ccdLogonCommandRejectedWrongOrUnknownGroupId",
        "500": "errorInternalServerError",
        "500000": "errorInternalServerError",
        "500600": "genericPCGInternalServerError",
        "500660": "ccdFeatureFailed",
        "500661": "ccdFeatureFailedUnknownDevice",
        "500662": "ccdFeatureFailedWrongUserType",
        "500663": "ccdFeatureFailedProacdIdCannotBeEmpty",
        "500664": "ccdFeatureFailedAgentDeviceTypeNotAuthorized",
        "500665": "ccdFeatureFailedNoProacdDeviceAvailable",
        "500666": "ccdFeatureFailedPBXRejectCCDCommand",
        "1001": "extensionNotLinkedToEquipment",
        "1002": "extensionHasNoIdentifier",
        "1003": "extensionDoesNotExist",
        "1004": "extensionLookupFailure",
        "1005": "extensionConflict",
        "1006": "nonUniqueEquipmentForExtension",
        "1007": "userAlreadyAssociatedToExtension",
        "1008": "extensionAssociatedToAnotherUser",
        "1009": "failedToAttachExtension",
        "1010": "userHasNoExtension",
        "1011": "userHasTooManyExtensions",
        "1012": "failedToDetachExtension",
        "2001": "companyHasNoCloudPbx",
        "2002": "extensionNumberNotCompatibleWithCloudPBXNumberingPlan",
        "2003": "extensionNumberAlreadyAssignedToAnotherUser",
        "2004": "userAlreadyAssignedToAnotherEquipment",
        "2005": "failedToAssociateExtensionNumber",
        "2006": "failedToUpdateExtensionNumber",
        "2007": "noSipDeviceWithMacAddress",
        "2008": "sipDeviceWithMacAddressBelongsToAnotherCompany",
        "2009": "sipDeviceWithMacAddressAttachedToAnotherUser",
        "2010": "anotherSipDeviceWithMacAddressAttachedToUser",
        "2011": "cannotManageSipDeviceForUserWithoutExtensionNumber",
        "2012": "failedToAttachSipDeviceToUser",
        "2013": "cannotManagePublicNumberForUserWithoutExtensionNumber",
        "2014": "publicNumberDoesNotExist",
        "2015": "publicNumberAlreadyAssociatedToAnotherUser",
        "2016": "anotherPublicNumberIsAttachedToUser",
        "2017": "failedToAttachPublicNumberToUser",
        "2018": "failedToDetachExtensionNumberNotProvided",
        "2019": "userAttachedToAnotherExtensionNumber",
        "2020": "cannotDetachPublicNumberFromUserWithoutExtensionNumber",
        "2021": "failedToDetachPublicNumberFromUser",
        "2022": "failedToDetachSipDeviceFromUser"
    };

    public static PORTAL_ERROR_CODE_LABELS: Record<string, Record<string, string>> = {
        subscription: {
            400980: "invalidPromoCodeFormat",
            400981: "invalidPromoCodeFormat",
            403389: "invalidCodeForPlan",
            403390: "invalidCodeForPlan",
            403391: "invalidPromoCodeForBusinessPartner",
            403392: "errorPromoCodeForbidden",
            403393: "errorDecreaseSubscriptionWithPromoCodeForbidden",
            403394: "errorRemoveSubscriptionWithPromoCodeForbidden",
            403395: "invalidPromoCodeForCompany",
            403614: "forbiddenDurationChangeBecausePriceChanges",
            404350: "errorPromoCodeNotFound",
            409633: "invalidComputePricePromoCode"
        },
        massprovisioning: {
            400000: "invalidValue",
            400501: "invalidFile",
            400502: "invalidColumnName",
            400504: "invalidFile",
            400505: "invalidValueInActionColumn",
            400506: "invalidValueInActionColumn",
            400507: "noUpdateLoginEmailPermission",
            400508: "noDataToImport",
            400600: "deviceTypeCannotBeUpdated",
            400601: "duplicateDeviceIds",
            400602: "duplicateMacAdresses",
            400603: "invalidDeviceTypes",
            400604: "missingDeviceTypeInLines",
            400605: "invalidEquipment",
            400972: "noCreateUserPermission",
            400973: "noCreateUserPermission",
            400980: "noUpdateUserPermission",
            400981: "noUpdateUserPermission",
            400984: "noUpdateUserPermission",
            400985: "noUpdateLoginEmailPermission",
            400990: "noDeleteUserPermission",
            400991: "noDeleteUserPermission",
            400994: "noUserFound",
            403610: "errorMaxSubscriptionReached",
            403622: "userDoesNotHaveVoiceLicense",
            404600: "deviceDoesNotExist",
            404601: "noCloudPbxInCompany"
        },
        rvcpprovisioning: {
            403622: "noVoiceLicenceAllocatedToUser",
            403684: "overflowConfigurationChangesStillInProgress",
            403694: "forbiddenOperationEquipmentHasGroups",
            403695: "publicNumberAlreadyDefault",
            403699: "forbiddenOperationEquipmentHasWelcomeService",
            403728: "forbiddenOperationEquipmentHasDevices",
            403739: "forbiddenOperationWelcomeServiceUsed",
            403744: "forbiddenOperationUserAlreadyAssocToWelcome",
            403745: "forbiddenOperationGroupAlreadyAssocToWelcome",
            403752: "forbiddenOperationMoreThanThreeConsecutiveMenus",
            403754: "forbiddenOperationMenuLinkedToAnotherMenu",
            403761: "forbiddenOperationUserLinkedToAutomatedAttendantMenu",
            403765: "forbiddenOperationMenuAlreadyLinkedToAnotherMenu",
            403767: "forbiddenOperationSubMenuLinkedToItsParent",
            409253: "forbiddenOperationCantAssignDeviceToAttendantUser",
            409556: "companyHasAlreadyACloudPbx",
            409560: "macAddressAlreadyUsed",
            409561: "deviceStillUsedByUser",
            409562: "deviceAlreadyUsed",
            409563: "deviceAlreadyUsedByAnotherSystem",
            409565: "forbiddenOperationCallForkingToPublicNumberUsedByCloudPbx",
            413000: "fileTooLarge",
            413001: "promptTooLong",
            415000: "audioFileTypeNotSupported",
            409566: "macAddressAlreadyUsed",
            400570: "tooManyCustomPrompt",
            403661: "greetingUploadNotAllowed",
            403662: "resourceNotSameSite",
            403818: "siteHasAlreadyDefaultNumber"
        },
        authentication: {
            401102: "authorizationFailure",
            401103: "authorizationFailure",
            401500: "authorizationFailure",
            401520: "Forbidden",
            401521: "Forbidden",
            401522: "Forbidden",
            401523: "Forbidden",
            401530: "authorizationFailure",
            401600: "authorizationFailure",
            401610: "passwordless_VerifCodeError",
            401612: "noValidToken",
            401700: "authorizationFailure",
            403000: "authorizationFailure",
            403538: "passwordless_codeSendingBlocked",
            500000: "errorInternalServerError",
            503000: "resourceNotFound"
        },
        webinar: {
            403135: "WebinarInvalidRegistrationId",
            409019: "webinarEmptyConversation"
        },
        vnauseradmin: {
            400006: "addressNotRecognizedByEmergencyService",
            400007: "E911ServiceUnavailable",
            400014: "yourAccountPublicNumberInvalid",
            400034: "yourAccountPublicNumberDoesNotExist",
            400059: "invalidAddress",
            400063: "invalidStateCode",
            400065: "invalidTelephoneNumberFormat",
            400201: "invalidBlankName",
            400202: "invalidBlankStreetName",
            400203: "invalidBlankStreetNumber",
            400204: "invalidBlankCity",
            400205: "invalidBlankState",
            400206: "invalidBlankZipCode",
            400207: "youMustHavePublicNumber",
            400208: "onlyNumericValuesAllowed",
            400209: "youMustHavePublicNumber",
            403153: "notAllowedToModifyAddress",
            405103: "invalidZipCode",
            409000: "errorLocationAddressConflict",
        },
        voice: {
            403797: "forbiddenOperationUserNotAttendant",
            403801: "forbiddenOperationUserInWaitingQueue",
            403802: "forbiddenOperationUserInHgOrMaGroup",
            403824: "notAllowedToConnectEmergencyGroup",
            413001: "promptTooLong",
        },
        telephonysupervision: {
            403083: "forbiddenOperationLogoutLastMemberNotAllowed",
            403382: "forbiddenOperationUserStatusIsLocked",
            403385: "forbiddenOperationNoAssistantAvailable",
        },
        admin: {
            403729: "cannotAddMemberWithIncompatibleLicense",
            403739: "calendarRemovedError",
            400130: "wrongParameters"
        },
        aihub: {
            500010: "aiErrorOnSave",
            400131: "aiApiKeyIncorrect",
            502001: "aiIssueOnCheckApiKey"
        }
    };

    private i18n: I18nService = I18nService.getInstance();

    public static getInstance() {
        return Service.create(ERROR_HELPER_SVC, ErrorHelperService);
    }

    public static build() {
        return new ErrorHelperService();
    }

    protected constructor() {
        super();
    }

    public async getErrorInfo(error: any, context: string = null, params: any = null) {
        const errorInfo = new ErrorHelperInfo();
        if (error instanceof Error) {
            errorInfo.message = error.message;
            errorInfo.error = error;
            if (error.message === "Failed to fetch") {
                errorInfo.error.translatedMessage = this.i18n.translate("IceConfigurationFailed");
            }
        }

        if (error instanceof Response) {
            let data;
            try {
                data = await error.json();
            } catch { /* don't care about this error : probably contains an HTML error page */ }
            const status = data?.errorDetailsCode ? data.errorDetailsCode === -1 && error.status ? error.status : data?.errorDetailsCode : error.status;
            const statusText = this.getStatusText(status, error);
            const errorText = this.getErrorText(data);
            const feature = this.getFeature(data);
            let portal: string;
            if (error.url && !error.url.includes('localhost') && !error.url.includes('drabedroc-demo') && !error.url.includes('sample-demo')) {
                const match = error.url.match(/api\/rainbow\/(\w+)\//);
                if (match?.length > 1) portal = match[1];
            }
            const requestId = (error.headers?.get("x-rainbow-request-id")) ? ` (x-rainbow-request-id:${error.headers.get("x-rainbow-request-id")})` : '';

            // Compute error message
            if (context) { errorInfo.message = `${context} -- `; }
            errorInfo.message += `${statusText} -- ${errorText}`;
            if (feature) { errorInfo.message += `-- ${feature}`; }
            if (requestId) { errorInfo.message += requestId; }

            // Create the error
            errorInfo.error = new Error(errorInfo.message);
            errorInfo.error.status = error.status;
            errorInfo.error.statusText = statusText;
            errorInfo.error.fieldErrors = this.getBadRequestFieldErrors(data, error);
            errorInfo.error.errorDetails = this.getTextWithoutIds(errorText);
            errorInfo.error.errorDetailsCode = status;
            errorInfo.error.errorDetailsLabel = this.getErrorCodeLabel(status, portal);
            try {
                errorInfo.error.translatedMessage = this.getTranslatedErrorMessage(errorInfo.error, params, portal);
            } catch (error) {
                //Noop
            }
            errorInfo.error.portal = portal;
            errorInfo.error.feature = feature;
            if (data?.errorDetailsData) errorInfo.error.errorDetailsData = data.errorDetailsData;
            errorInfo.error.fullResponseData = data;
        }
        return errorInfo;
    }

    private getTranslatedErrorMessage(error: any, params: any, portal: string): string {
        let errorMessage = '';
        if (error.errorDetailsCode) {
            errorMessage = this.getLocalizedError(error.errorDetailsCode, params, portal);
            if (!errorMessage) { errorMessage = this.i18n.translate("anErrorOccurred", { errorcode: error.errorDetailsCode }); }
        }
        return errorMessage;
    }

    public getLocalizedError(errorCode: string, params: any, portal: string): string {
        let errorMessage = '';
        const errorLabel = this.getErrorCodeLabel(errorCode, portal);
        if (errorLabel) {
            const translation = this.i18n.translate(errorLabel, params);
            if (translation !== errorLabel) { errorMessage = translation; }
        }
        return errorMessage;
    }

    private getErrorText(data: any): string {
        if (!data) return 'Unknow error - Something goes really wrong';
        let message = '';
        if (data.errorDetails) {
            if (data.errorDetails instanceof Array) { data.errorDetails.forEach((details: any) => { message += details.msg; }); }
            else {
                if (data.errorDetails.msg) { message += JSON.stringify(data.errorDetails.msg); }
                else if (data.errorDetails.details) { message += data.errorDetails.details; }
                else { message += (typeof data.errorDetails === "string" ? data.errorDetails : JSON.stringify(data.errorDetails)); }
            }
        } else if (data.errorMsg) {
            message += data.errorMsg;
        }
        return message;
    }

    private getTextWithoutIds(message: string): string {
        return message?.replace(new RegExp("\\s[\\d]{1}[a-f\\d]{23}", "g"), "");
    }

    private getFeature(data: any): string | undefined {
        if (data?.errorDetails && !(data.errorDetails instanceof Array) && data.errorDetails.feature) {
            return String(data.errorDetails.feature);
        }
        return undefined;
    }

    private getStatusText(status: any, response: Response): string {
        switch (status) {
            case -1: return "Service unavailable"; //TODO not translated !!
            case 400: return "badRequest";
            case 401: return "authorizationFailure";
            case 403: return "accessForbidden";
            case 404: return "resourceNotFound";
            case 413: return "requestEntityTooLarge";
            case 415: return "unsupportedMediaType";
            case 429: return "Too many requests"; //TODO not translated !!
            case 500: return "internalServerError";
            case 403503: return "NotAllowedSelfRegistrationEmail";
            default: return response.statusText ? response.statusText : "unknownError";
        }
    }

    private getBadRequestFieldErrors(data: any, response: Response): any {
        const fieldErrors: any = {};
        const errorDetails = data ? data.errorDetails : null;
        const errorDetailsCode = data ? data.errorDetailsCode : null;
        const errorDetailsData = data ? data.errorDetailsData : null;

        if (response.status === 400) { // Bad request
            if (errorDetails) {
                if (errorDetails instanceof Array) {
                    errorDetails.forEach((details: any) => {
                        if (!fieldErrors[details.param]) { // do not override if already exists
                            fieldErrors[details.param] = { ok: false, message: details.msg, value: details.value };
                        }
                    });
                }
                else if (errorDetails.param) {
                    if (!fieldErrors[errorDetails.param]) { // do not override if already exists
                        fieldErrors[errorDetails.param] = { ok: false, message: errorDetails.msg, value: errorDetails.value };
                    }
                }
            }
            if (errorDetailsCode === 400511) {
                fieldErrors.office365Tenant = { ok: false, message: ErrorHelperService.ERROR_CODE_LABELS["400511"] };
            }
            if (errorDetailsCode === 400601) {
                fieldErrors.outgoingPrefix = { ok: false, message: ErrorHelperService.ERROR_CODE_LABELS["400601"] };
                fieldErrors.numberingPrefix = { ok: false, message: ErrorHelperService.ERROR_CODE_LABELS["400601"] };
            }
        } else if (response.status === 409) { // Conflict
            if (errorDetailsCode === 409000 && errorDetailsData) {
                if (errorDetailsData.loginEmail) {
                    fieldErrors.loginEmail = { ok: false, label: "userAlreadyExist" }; // prefer "label" instead of "message" field
                }
                if (errorDetailsData.authenticationExternalUid) {
                    fieldErrors.authenticationExternalUid = { ok: false, label: "userIdAlreadyUsed" }; // prefer "label" instead of "message" field
                }
            }
        }
        return fieldErrors;
    }

    private getErrorCodeLabel(errorCode: string, portal: string): string {
        if (portal && ErrorHelperService.PORTAL_ERROR_CODE_LABELS[portal] && ErrorHelperService.PORTAL_ERROR_CODE_LABELS[portal][errorCode]) {
            const toto = ErrorHelperService.PORTAL_ERROR_CODE_LABELS[portal][errorCode];
            return toto;
        }
        return ErrorHelperService.ERROR_CODE_LABELS[errorCode];
    }
}
